import 'regenerator-runtime/runtime';
import { initSwiper } from "../components/common";

export function openModal(e) {
    e?.preventDefault();
    const productCard = $(this);
    if ($('.block-product-cards__product.active').length) {
        return;
    }
    if (!productCard.hasClass('active')) {
        $('.block-product-cards .block-product-cards__product').removeClass('active');
        productCard.find('.swiper').get().forEach(swiper => {
            initSwiper(swiper);
        });
    }
    productCard.addClass('active');
    $('body').addClass('modal-opened');
}

export function closeModal(e, productCard) {
    e?.stopPropagation();
    productCard = productCard ?? $(this).closest('.block-product-cards__product');
    if (productCard.hasClass('active')) {
        productCard.find('.swiper').get().forEach(swiper => {
            swiper?.swiper?.destroy(true, true);
        });
    }
    productCard.removeClass('active');
    $('body').removeClass('modal-opened');
}

export function closeModalOnClickOutside(e) {
    if ($(e.target).closest(".block-product-cards__product.active").length === 0) {
        const activeProduct = $('.block-product-cards__product.active');
        closeModal(e, activeProduct);
    }
}

export default function init() {
    $(document).on('click', '.block-product-cards .block-product-cards__product', openModal);
    $(document).on('click', '.block-product-cards .block-product-cards__product .close-modal', closeModal);
    $(document).on('click', 'body.modal-opened', closeModalOnClickOutside);
}